import React from 'react'
import styled, { css } from 'styled-components'

const Button = styled.button`
  position: fixed;
  top: 3rem;
  right: 1rem;
  z-index: 1000;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;

  @media screen and (min-width: 880px) {
    right: 3rem;
  }

  &:focus-visible {
    outline: 2px solid rgb(var(--tltr-awesome-value));
    outline-offset: 4px;
    border-radius: 2px;
  }

  &:hover span {
    opacity: 1;
  }

  &:hover span:last-child {
    width: 1.5rem;
  }

  @media (prefers-reduced-motion: reduce) {
    span {
      transition: none !important;
    }
  }
`

const Bar = styled.span`
  display: block;
  width: 1.5rem;
  height: 1.5px;
  opacity: 0.5;
  transition:
    transform 0.3s ease,
    opacity 0.15s ease,
    width 0.3s ease;
  transform-origin: center;

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          background-color: rgb(var(--text-color));
        `
      : css`
          background-color: rgb(var(--text-color));
        `}
`

const TopBar = styled(Bar)`
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: translateY(4px) rotate(45deg);
    `}
`

const BottomBar = styled(Bar)`
  width: 1rem;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      width: 1.5rem;
      transform: translateY(-4px) rotate(-45deg);
    `}
`

const HamburgerButton = React.forwardRef(({ isOpen, onClick }, ref) => (
  <Button
    ref={ref}
    onClick={onClick}
    aria-expanded={isOpen}
    aria-controls="nav-overlay"
    aria-label={isOpen ? 'Close menu' : 'Open menu'}
  >
    <TopBar $isOpen={isOpen} />
    <BottomBar $isOpen={isOpen} />
  </Button>
))

HamburgerButton.displayName = 'HamburgerButton'

export default HamburgerButton
